import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

export default function EntitySelect({
  options,
  value,
  onChange,
  disabled,
  errorText,
  required
}) {
  return (
    <div className="form-input-expense">
      <label className="form-input-label-expense">Entity*</label>

      <Autocomplete
        options={options}
        getOptionLabel={(opt) => opt?.Name ?? ''}
        value={value}
        onChange={onChange}
        disablePortal
        fullWidth
        disabled={disabled}
        className="mui-input"
        isOptionEqualToValue={(opt, val) =>
          String(opt?.StaffID) === String(val?.StaffID)
        }

        // ✅ Custom option rendering
        renderOption={(props, option) => {
          const label = option?.Name ?? '';

          // Split "Name (Extra)"
          const match = label.match(/^(.*?)(\s*\(.*\))?$/);
          const mainText = match?.[1] ?? label;
          const extraText = match?.[2] ?? '';

          return (
            <li {...props}>
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                <span>{mainText}</span>
                {extraText && (
                  <span style={{ color: '#9e9e9e' }}>
                    {extraText}
                  </span>
                )}
              </Box>
            </li>
          );
        }}

        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select entity..."
            error={!!errorText}
            helperText={errorText || ''}
            required={required}
          />
        )}
      />
    </div>
  );
}
